import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Book, Eye, Calendar, ClipboardCheck, AlertTriangle } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    issue: 'Tu sesión diaria',
    without: 'Improvisás',
    with: 'Criterio exacto para cada momento'
  }, {
    issue: 'Señales del perro',
    without: 'No sabés qué estás viendo',
    with: 'Atlas visual completo de 40+ señales'
  }, {
    issue: 'Segunda semana',
    without: 'Dudas y hesitación',
    with: 'Auditoría semanal que detecta desvíos'
  }, {
    issue: 'Retrocesos',
    without: 'Sin protocolo claro',
    with: '5 protocolos de crisis listos'
  }, {
    issue: 'El vecino',
    without: 'Sin saber qué decirle',
    with: 'Guion exacto para usar hoy mismo'
  }, {
    issue: 'Paseo reactivo',
    without: 'Caos y frustración',
    with: 'Secuencia de 30 segundos'
  }, {
    issue: 'Paseador/guardería',
    without: 'Sin criterio para elegir',
    with: 'Checklist completo de evaluación'
  }];
  const modules = [{
    icon: <Book className="w-6 h-6 text-gold-400" data-id="element-40" />,
    title: '📕 Módulo 1 — La Postura del Guía',
    desc: 'Cuerpo, voz y energía. El Ritual de 60 Segundos que cambia el resultado de cada sesión.'
  }, {
    icon: <Eye className="w-6 h-6 text-gold-400" data-id="element-41" />,
    title: '📗 Módulo 2 — Atlas Visual de Señales Caninas',
    desc: '40+ señales de calma, escalada y bienestar. Sabés qué está pasando antes de que pase.'
  }, {
    icon: <Calendar className="w-6 h-6 text-gold-400" data-id="element-42" />,
    title: '📘 Módulo 3 — El Diario de los 21 Días',
    desc: 'Implementación exacta día por día con criterios precisos para saber cuándo avanzar.'
  }, {
    icon: <ClipboardCheck className="w-6 h-6 text-gold-400" data-id="element-43" />,
    title: '📙 Módulo 4 — Tablero de Auditoría Semanal',
    desc: 'Revisión estructurada cada 7 días para detectar desvíos antes de que sean semanas perdidas.'
  }, {
    icon: <AlertTriangle className="w-6 h-6 text-gold-400" data-id="element-44" />,
    title: '📓 Módulo 5 — Gestión de Crisis',
    desc: 'Retrocesos, vecinos, semanas perdidas, perro enfermo. Un protocolo para cada emergencia.'
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-45">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-46">
        <div className="text-center mb-10" data-id="element-47">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-48">
            🐾 ¿QUÉ AGREGA EL PACK COMPLETO?
          </h3>
          <p className="text-blue-200 text-lg max-w-2xl mx-auto" data-id="element-49">
            El sistema de implementación diaria que hace que el protocolo
            funcione con precisión desde el Día 1.
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-navy-700 bg-navy-800/30 mb-16" data-id="element-50">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-51">
            <thead data-id="element-52">
              <tr data-id="element-53">
                <th className="p-4 md:p-6 border-b border-navy-700 w-1/3 text-gray-400 font-medium" data-id="element-54">
                  Situación
                </th>
                <th className="p-4 md:p-6 border-b border-navy-700 bg-navy-900/50 text-center text-gray-400 font-medium w-1/3" data-id="element-55">
                  Sin Acelerador
                </th>
                <th className="p-4 md:p-6 border-b border-navy-700 bg-gold-500/10 text-center text-gold-400 font-bold w-1/3" data-id="element-56">
                  Con Acelerador
                </th>
              </tr>
            </thead>
            <tbody data-id="element-57">
              {rows.map((row, index) => <tr key={index} className="border-b border-navy-700/50 last:border-0 hover:bg-navy-800/50 transition-colors" data-id="element-58">
                  <td className="p-4 md:p-6 text-blue-50 font-medium" data-id="element-59">
                    {row.issue}
                  </td>
                  <td className="p-4 md:p-6 bg-navy-900/30 text-center text-gray-500" data-id="element-60">
                    <X className="w-5 h-5 mx-auto mb-1 opacity-50" data-id="element-61" />
                    <span className="text-sm" data-id="element-62">{row.without}</span>
                  </td>
                  <td className="p-4 md:p-6 bg-gold-500/5 text-center text-white" data-id="element-63">
                    <Check className="w-5 h-5 mx-auto mb-1 text-gold-400" data-id="element-64" />
                    <span className="text-sm" data-id="element-65">{row.with}</span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="bg-navy-800/50 border border-gold-500/30 rounded-3xl p-8 md:p-10" data-id="element-66">
          <h4 className="text-2xl font-bold text-white mb-8 text-center flex items-center justify-center gap-2" data-id="element-67">
            <Check className="w-6 h-6 text-green-400" data-id="element-68" /> EL ACELERADOR DE
            CALMA™ INCLUYE:
          </h4>

          <div className="space-y-6 mb-8" data-id="element-69">
            {modules.map((mod, i) => <div key={i} className="flex items-start gap-4" data-id="element-70">
                <div className="mt-1 p-2 bg-navy-900 rounded-lg shrink-0" data-id="element-71">
                  {mod.icon}
                </div>
                <div data-id="element-72">
                  <h5 className="text-lg font-bold text-white mb-1" data-id="element-73">
                    {mod.title}
                  </h5>
                  <p className="text-blue-100/80" data-id="element-74">{mod.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="bg-navy-900/80 rounded-2xl p-6 border border-navy-700" data-id="element-75">
            <h5 className="text-gold-400 font-bold mb-4 flex items-center gap-2" data-id="element-76">
              📊 Assets incluidos:
            </h5>
            <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-blue-50" data-id="element-77">
              <span className="flex items-center gap-2" data-id="element-78">
                <Check className="w-4 h-4 text-green-400" data-id="element-79" /> Diario de 21 días
                completo
              </span>
              <span className="flex items-center gap-2" data-id="element-80">
                <Check className="w-4 h-4 text-green-400" data-id="element-81" /> Tablero de
                auditoría semanal
              </span>
              <span className="flex items-center gap-2" data-id="element-82">
                <Check className="w-4 h-4 text-green-400" data-id="element-83" /> Atlas de señales
                caninas
              </span>
              <span className="flex items-center gap-2" data-id="element-84">
                <Check className="w-4 h-4 text-green-400" data-id="element-85" /> Protocolo vecino
                amigable
              </span>
              <span className="flex items-center gap-2" data-id="element-86">
                <Check className="w-4 h-4 text-green-400" data-id="element-87" /> Secuencia SOS paseo
                reactivo
              </span>
              <span className="flex items-center gap-2" data-id="element-88">
                <Check className="w-4 h-4 text-green-400" data-id="element-89" /> Checklist
                paseador/guardería
              </span>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}